import { Fragment, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import { Page } from 'components/Page';
import { usePermissions } from 'features/permissions';
import { Applicants } from 'pages/Applicants';
import Job from 'pages/Job';
import ApplicationContainer from 'pages/Job/Application';
import ApplicationOnboarding from 'pages/Job/ApplicationOnboarding';
import JobList from 'pages/JobList';
import { Messages } from 'pages/messages';
import { Notifications } from 'pages/notifications/notification';
import Onboarding from 'pages/Onboarding';
import Sharing from 'pages/Sharing';
import SlackAuth from 'pages/Slack';

export const MainRouteConfig = observer(function MainRouteConfig() {
  const { hasRolePermission } = usePermissions();

  return (
    <Page id="page-content-area">
      <Suspense fallback={null}>
        <Routes>
          {hasRolePermission('application:onboarding') && (
            <Route path="jobs/:jobID/onboarding/:appID/*" element={<ApplicationOnboarding />} />
          )}

          {hasRolePermission('jobs:view') && <Route path="jobs" element={<JobList />} />}

          {hasRolePermission('job:view') && (
            <Fragment>
              <Route path="/jobs/:jobID/*" element={<Job />} />
              <Route
                path="/jobs/:jobID/application/:applicationID/*"
                element={<ApplicationContainer />}
              />
            </Fragment>
          )}

          {hasRolePermission('applicants:view') && (
            <Route path="applicants" element={<Applicants />} />
          )}

          {hasRolePermission('applicants:view') && (
            <Route path="onboarding" element={<Onboarding />} />
          )}

          {hasRolePermission('applicants:view') && <Route path="messages" element={<Messages />} />}

          <Route path="sharing" element={<Sharing />} />

          {hasRolePermission('slack:auth') && <Route path="slack/auth" element={<SlackAuth />} />}
          {hasRolePermission('notifications:view') && (
            <Fragment>
              <Route path="notifications/" element={<Notifications />} />
              <Route path="notifications/:section/" element={<Notifications />} />
            </Fragment>
          )}

          <Route
            path="*"
            element={<Navigate to={hasRolePermission('jobs:view') ? 'jobs' : 'sharing'} replace />}
          />
        </Routes>
      </Suspense>
    </Page>
  );
});
